import * as moment from 'moment';

export function getCurrentHoursAndMinutes() {
    return `${moment().toDate().getHours()}:${moment().toDate().getMinutes()}`
}

export function getStartMonthDate(calendarDate) {
    const firstDay = moment(calendarDate).date(1).toDate();
    const dayOffset = firstDay.getDay();
    return dayOffset > 0 ?
        moment(firstDay).subtract(dayOffset, 'days').toDate()
        : firstDay;
}

export function getEndMonthDate(calendarDate) {
    const daysInMonth = moment(calendarDate).daysInMonth();
    const lastDay = moment(calendarDate).date(daysInMonth).toDate();
    const dayOffset = 7 - lastDay.getDay() - 1;
    return dayOffset > 0 ?
        moment(lastDay).add(dayOffset, 'days').toDate()
        :lastDay;
}

export function getStartWeekDate(calendarDate) {
    return moment(calendarDate).startOf('week').toDate();
}

export function getEndWeekDate(calendarDate) {
    return moment(calendarDate).endOf('week').toDate();
}

export function showTwoDates(date1, date2) {
    const date1TT = moment(date1).format('A');
    const date2TT = moment(date2).format('A');
    return `${moment(date1).format('hh:mm A')} - ${moment(date2).format('hh:mm A')}`;
}


// WEBPACK FOOTER //
// ./src/utils/dates.js